$(document).on('keydown', function(e) {
    if (e.key === "Escape") {
      // Remove 'active' class from the menu
      $(".fhd").removeClass("active");
      // Set 'aria-expanded' attribute to 'false' for all anchor tags within .fhd elements
      
    }
  });
  
  $(document).on('click', function(e) {
    // Check if the clicked element is not part of the menu
    if (!$(e.target).closest('.fhd').length) {
      // Remove 'active' class from the menu
      $(".fhd").removeClass("active");
      // Set 'aria-expanded' attribute to 'false' for all anchor tags within .fhd elements
      
    }
  });
  $(document).ready(function() {

    function updateTables() {
  
      $('table').each(function() {
        var $table = $(this);
  
        var hasHeader = $table.find('thead').length > 0;
  
        if (!hasHeader) {
          $table.attr('role', 'presentation');
        } else {
  
          $table.find('tbody td').each(function() {
            var $cell = $(this);
            var index = $cell.index() + 1;
  
            if ($table.find('thead th:nth-child(' + index + ')').length === 0) {
    
              var content = $cell.html();
              $cell.replaceWith('<th>' + content + '</th>');
            }
          });
        }
      });
    }
  
    updateTables();
  });

  $(document).ready(function() {
    $('button.list-view-button').attr('aria-label','Click for List View');
    $('button.grid-view-button').attr('aria-label','Click for Grid View');
    $('button.active-button').attr('aria-selected','true');
    $('.section.clearfix.collection_description a').attr('aria-label','Click to Read more... and continue reading');
    $('select[name="currency"]').attr('aria-label','currency');
$('div#newsletterDiv button#subscribe').attr('aria-label', 'Subscribe, The Page Will Refresh after submission');

  
  });
  var priceRangeSliderMin = document.getElementById('price-range-slider-min');
  priceRangeSliderMin.setAttribute('aria-label', 'Minimum Price Range');

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.mfp-container');
    var closeButton = container.querySelector('.mfp-close');
    var nextButton = container.querySelector('.mfp-arrow-right');

    // Move close button after the next button
    container.insertBefore(closeButton, nextButton.nextSibling);
  });
$(document).ready(function () {
    var existCondition = setInterval(function () {
        if ($('.dropdown button').length) {
            clearInterval(existCondition);
            runMyFunctionrmvtblog();
        }
    }, 200);

    function runMyFunctionrmvtblog() {
        // Set aria-expanded to false by default
        $('.dropdown button').attr('aria-expanded', 'false');

        // Add a click event listener to the button
        $('.dropdown button').click(function() {
            // Toggle the aria-expanded attribute
            var expanded = $(this).attr('aria-expanded') === 'false';
            $(this).attr('aria-expanded', expanded ? 'true' : 'false');
        });
    }
});


